export function updatePlanet(planet, position) {
  return {
    type: 'UPDATE_PLANET',
    payload: planet,
    position,
  };
}

export function generateStartLocation(planet) {
  return {
    type: 'GENERATE_START_LOCATION',
    payload: planet,
  };
}
